import { Button, Trash } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { styled } from 'styled-components'

type DeleteButtonProps = {
  onClick: () => void
  children?: string
}

export const DeleteButton = ({ onClick, children }: DeleteButtonProps) => {
  return (
    <StyledButton onClick={onClick} data-cy="form-delete-btn">
      <Trash />
      <Text weight="medium">{children}</Text>
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  color: ${(props) => props.theme.color.neutral.color4};
`
